import { render, staticRenderFns } from "./OrderCommentsHistory.vue?vue&type=template&id=6bd5b20b&scoped=true&"
import script from "./OrderCommentsHistory.vue?vue&type=script&lang=js&"
export * from "./OrderCommentsHistory.vue?vue&type=script&lang=js&"
import style0 from "./OrderCommentsHistory.vue?vue&type=style&index=0&id=6bd5b20b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd5b20b",
  null
  
)

export default component.exports